export default __webpack_public_path__ + "static/media/comingsoon.3344e2fa.svg";